/* eslint-disable class-methods-use-this */
import videojs from 'video.js';
import './CustomLoadingSpinner.css';

// Get BigPlayButton class
const LoadingSpinner = videojs.getComponent('LoadingSpinner');

// Extend BigPlayButton class and define innerHtml and class name - with 'vjs-' convention
class CustomLoadingSpinner extends LoadingSpinner {
  createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-custom-loading-spinner',
      innerHTML: `<div class="spinner"></div>`,
    });
  }
}

// Register new CustomBigPlayButton component class
videojs.registerComponent('CustomLoadingSpinner', CustomLoadingSpinner);
